define('adminResTransView',[
    'module',
    'marionette',
    'underscore',
    'app',
    'settings',
    'jqgridView',
    'template!adminResTransListTpl'
], function (
    module,
    Marionette,
    _,
    App,
    Settings,
    JqGridView,
    viewTpl
    ) {
    'use strict';

    var ResTransListView = JqGridView.extend({
        template: viewTpl,
        filtersName: 'restransListFilters',

        triggers: {},

        ui: function() {
            return _.extend({
                jqGrid: '#jq-grid-list',
                jqGridPager: '#jq-grid-pager-list',
                deleteResTrans: '.delete-restrans-link'
            }, this.gridUi);
        },

        events: function() {
            return _.extend({
                'click @ui.deleteResTrans': 'onDeleteResTrans'
            }, this.gridEvents);
        },

        serializeData: function() {
            var templateData = {
                type: 'restrans',
                data: this.options.data
            };
            return templateData;
        },

        pagination: function() {
            return {
                first: 0,
                rowCount: 0,
                pageSize: Settings.get('perPage15'),
                currentPage: 1
            };
        },

        onDeleteResTrans: function(event){
            this.trigger('restrans:delete', this.options.data.model.get('secId'), $(event.currentTarget).find('span').attr('data-row-id'));
        },

        gridOptions: function(data) {
            var options = {
                colModel: [
                    {
                        label: '',
                        name: 'secId',
                        key: true,
                        hidden: true
                    }, {
                        label: _.i18n('restrans.res'),
                        name: 'res',
                        classes: 'restrans-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'res'
                    }, {
                        label: _.i18n('restrans.name'),
                        name: 'name',
                        classes: 'restrans-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'name'
                    }, {
                        label: _.i18n('restrans.comment'),
                        name: 'comment',
                        classes: 'restrans-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'comment'
                    }, {
                        label: ' ',
                        name: 'delete',
                        search: false,
                        classes: 'delete-restrans-link delete-link',
                        formatter: this.deleteIconFormatter,
                        width: 20
                    }
                ],

                onSelectRow: function(rowId, bool, e) {                    
                    if (!$(e.target).hasClass('cell-delete') && e.type === 'click') {
                        if (e.type === 'click') {
                            App.navigate('admin/restrans' + '/' + rowId + '/detail', {trigger: true});
                        }
                    }
                }
            };

            options = _.defaults(options, this.gridInitOptions(data));

            return options;
        }
    });

    module.exports = ResTransListView;
});
